import axios from "axios";

import { getAppConfigSetting } from "../../../utils/getAppConfigSetting";
import { MenuItem } from "../types";

const menuItemsURL = `${getAppConfigSetting(
  "apiUrl"
)}/legit/api/v2/session/menuItems`;

export const fetchMenuItems = async (): Promise<MenuItem[]> => {
  try {
    const { data } = await axios.get<MenuItem[]>(menuItemsURL, {
      withCredentials: true,
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
